// nnkitodo [v2later language] gérer avec fonctionnalités

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { LanguageService } from '../services/language.service';

@Injectable({
  providedIn: 'root',
})
export class PrepSSMGuard implements CanActivate {
  constructor(private router: Router, private languageService: LanguageService) {}

  canActivate() {
    if (this.languageService.isPrepSSM()) {
      this.router.navigate(['/app/home']);
      return false;
    } else {
      return true;
    }
  }
}
